import { env } from '@monorepo/env'

export const log = (...args: any[]) => {
  if (env.NODE_ENV === 'development') {
    console.log(...args)
  }
}
